import React, { useState } from 'react';
import { Search as SearchIcon } from '@mui/icons-material';
import { InputAdornment, TextField } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { lightTheme } from '@gojitsu/web-ui-core';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useRecoilState } from 'recoil';
import { emailLogState } from '../../atoms/EmailLogState';

const useStyles = makeStyles()((theme) => ({
  searchForm: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
  },
  searchInput: {
    flexGrow: 2,
    backgroundColor: '#fff',
    '&>.MuiInputBase-root': {
      fontSize: 14,
      '&>.MuiOutlinedInput-input': {
        paddingTop: '20px',
        paddingBottom: '20px',
      },
    },
  },

  searchBtn: {
    width: 200,
    marginLeft: 20,
    height: 56,
    borderRadius: 3,
    backgroundColor: lightTheme.palette.secondary.main,
    color: 'rgb(255, 255, 255)',
    fontSize: '15px',
    fontWeight: 600,
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
  },
  closeBtn: {
    padding: 8,
  },
  select: {
    width: 180,
  },
}));

const SearchForm = ({ getList, initValue, placeholder }) => {
  const [emailLogs, setEmailLogs] = useRecoilState(emailLogState);
  const { classes } = useStyles();
  const [keyword, setKeyword] = useState(initValue);
  // const [selectField, setSelectField] = useState(null);

  const handleSearch = (e) => {
    e.preventDefault();
    setEmailLogs({ ...emailLogs, search_text: keyword });
    return false;
  };

  const handleChangeSearch = (event) => {
    setKeyword(event.target.value);
  };

  const handleResetSearch = (e) => {
    setKeyword('');
    setEmailLogs({ ...emailLogs, search_text: null });
    return false;
  };

  return (
    <form className={classes.searchForm} noValidate autoComplete="off">
      <TextField
        onChange={handleChangeSearch}
        value={keyword}
        variant="outlined"
        id="standard-start-adornment"
        className={classes.searchInput}
        placeholder={placeholder}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment className={classes.searchIcon} position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: keyword && (
              <IconButton className={classes.closeBtn} onClick={() => handleResetSearch()} size="large">
                <CloseIcon className={classes.closeIcon} />
              </IconButton>
            ),
          },
        }}
      />
      <button className={classes.searchBtn} onClick={handleSearch}>
        Search
      </button>
    </form>
  );
};
export default React.memo(SearchForm);
